import React from 'react';
import Itinary from '../../../../widgets/Itinary';

const MerchantAddress = ({ merchant }) => {
  if (!merchant.address) {
    return null;
  }

  return (
    <div
      className="sl-flex sl-flex-col sl-gap"
      itemProp="address"
      itemScope
      itemType="https://schema.org/PostalAddress"
    >
      <address
        className="sl-flex sl-flex-col sl-gap-s"
        style={{ fontStyle: 'normal' }}
      >
        <p itemProp="streetAddress">{merchant.address.street}</p>
        <div className="flexGap">
          <p>
            <span itemProp="postalCode">{merchant.address.zip}</span>{' '}
            <span itemProp="addressLocality">{merchant.address.city}</span>
          </p>
        </div>
      </address>
      <Itinary merchant={merchant} />
    </div>
  );
};

export default MerchantAddress;
